module.exports = __webpack_public_path__ + "static/img/RSUPS108_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RSUPS108_1.png
// module id = TJWm
// module chunks = 0